import { ChevronRight, Clear } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    Grid,
    IconButton,
    Paper,
} from '@mui/material';
import { Button, Typography } from '@uhc-tempo/components';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { FormContext } from '../../../context/Form.context';
import AverageThresholdTag from './AvgTag.component';
import useDetectMobile from '../../../utils/customHooks/useDetectMobile';
import formatNumberToCurrency from '../../../utils/NumberUtil';
import { allProviderSpecialties } from '../../../utils/ProviderUtil';
import { checkIndemnityCoverages } from '../../../utils/SearchPageUtil';
import { getMemberPays } from '../../../utils/costBreakdownUtil';

const OtherLocationsModal = (props) => {
    const {
        estimate,
        provider,
        handleViewSingleProvider,
        topLocation,
        setTopLocation,
        otherLocationsOpen,
        handleOtherLocationsClose,
    } = props;
    const [otherLocationsDialog, setOtherLocationsDialog] = useState(false);
    const { memberDetails, formValues } = useContext(FormContext);
    const { selectedService } = formValues;

    useEffect(() => {
        if (otherLocationsOpen) {
            setOtherLocationsDialog(true);
        } else {
            setOtherLocationsDialog(false);
        }
    }, [otherLocationsOpen]);

    useEffect(() => {
        if (otherLocationsDialog) {
            if (document.getElementById('otherLocationsDialogChildDiv')) {
                // Desktop View and Mobile View
                document.getElementById('otherLocationsDialogChildDiv').focus();
            }
        }
    }, [otherLocationsDialog]);

    const [showOtherLocationsModal, setShowOtherLocationsModal] = useState(false);

    const ref = useRef(null);
    const isDesktopView = useDetectMobile(ref);

    const costShare = estimate?.costShare;
    const geoAverageCost = estimate?.geoAverageCost;
    const costScale = estimate?.costScale;
    const isIndemnity = checkIndemnityCoverages(memberDetails, true);

    const handleModalClose = () => {
        handleOtherLocationsClose();
    };

    const handleViewingSingleProvider = () => {
        // this should pass setters and props here
        handleViewSingleProvider();
        handleOtherLocationsClose();
    };

    const handlesetTopLocation = (newLocation) => {
        handleViewSingleProvider();
        setTopLocation(newLocation);
        handleOtherLocationsClose();
    };

    const renderAllLocations = () => {
        return provider?.locAndPractRole?.length > 0
            ? provider.locAndPractRole?.map((location, index) =>
                  renderLocationCard(location.singleAddress, index)
              )
            : [];
    };

    const renderAllLocationsMobile = () => {
        return provider?.locAndPractRole?.length > 0
            ? provider.locAndPractRole?.map((location, index) =>
                  renderLocationCardMobile(location.singleAddress, index)
              )
            : [];
    };

    const renderLocationCardMobile = (location, index) => {
        return (
            <React.Fragment key={index}>
                <Grid
                    item
                    xs={12}
                    aria-label={`locationCard${index}`}
                    label={`locationCard${index}`}
                    key={location.locationId}
                    sx={{ paddingTop: '20px' }}
                >
                    <Grid container spacing={2.5} justifyContent="space-between" direction="column">
                        <Grid item>
                            <Paper
                                style={{
                                    borderRadius: '8px',
                                    border:
                                        topLocation === index
                                            ? '4px solid rgba(25, 110, 207, 1)'
                                            : '0px',
                                    boxShadow: '0px 0px 6px rgba(0,0,0,0.2)',
                                }}
                                variant="outlined"
                                sx={{
                                    paddingX: '24px',
                                    paddingY: '24px',
                                }}
                            >
                                <Grid container justifyContent="space-between">
                                    <Grid item xs={12}>
                                        <Typography.Paragraph
                                            style={{
                                                color: '#333333',
                                                fontWeight: '500',
                                                fontSize: '14.22px',
                                                marginBottom: '0px',
                                            }}
                                        >
                                            {location.line[0]}, {location.city}, {location.state}{' '}
                                            {location.zipCode}
                                        </Typography.Paragraph>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{ marginTop: '16px', marginBottom: '8px' }}
                                    >
                                        <Grid container justifyContent="space-between">
                                            <Grid item xs={12} sx={{ marginBottom: '14px' }}>
                                                <Grid container alignItems="center">
                                                    <Typography.Paragraph
                                                        style={{
                                                            color: '#5A5A5A',
                                                            marginBottom: '0px',
                                                            fontWeight: '500',
                                                            fontSize: '16px',
                                                        }}
                                                    >
                                                        You pay:
                                                    </Typography.Paragraph>
                                                    <Typography.Paragraph
                                                        data-testid="estimatePrice"
                                                        style={{
                                                            color: '#333333',
                                                            marginBottom: '0px',
                                                            fontWeight: '700',
                                                            fontSize:
                                                                costShare?.outOfPocket ||
                                                                costShare?.outOfPocket == 0
                                                                    ? '25.63px'
                                                                    : '16px',
                                                            marginLeft: '8px',
                                                        }}
                                                    >
                                                        {getMemberPays(estimate, 'Not Available')}
                                                    </Typography.Paragraph>
                                                </Grid>
                                            </Grid>
                                            {/* <Grid item>
                                                {geoAverageCost &&
                                                    !isIndemnity[
                                                        selectedService?.value?.fullCarePath
                                                            ?.coverageTypeCode
                                                    ] && (
                                                        <AverageThresholdTag
                                                            costScale={costScale}
                                                            cost={costShare?.outOfPocket}
                                                            currentDialogState={
                                                                showOtherLocationsModal
                                                            }
                                                            setDialogState={
                                                                setShowOtherLocationsModal
                                                            }
                                                        />
                                                    )}
                                            </Grid> */}
                                            {/* //commenting out the average tag for now but will put behind feature flag */}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {topLocation === index ? (
                                            <Grid container direction="column">
                                                <Grid item>
                                                    <Grid
                                                        container
                                                        alignItems="center"
                                                        direction="row"
                                                    >
                                                        <CheckCircleIcon
                                                            style={{
                                                                color: '#196ECF',
                                                                height: '16px',
                                                                width: '16px',
                                                                marginRight: '8px',
                                                            }}
                                                        />
                                                        <Typography.Paragraph
                                                            style={{
                                                                color: '#333333',
                                                                marginBottom: '0px',
                                                                fontWeight: '400',
                                                                fontSize: '14.22px',
                                                            }}
                                                        >
                                                            This facility is currently selected
                                                        </Typography.Paragraph>
                                                    </Grid>
                                                </Grid>
                                                <Grid item sx={{ marginTop: '13px' }}>
                                                    <Grid
                                                        container
                                                        alignItems="center"
                                                        direction="row"
                                                    >
                                                        <Typography.Paragraph
                                                            onClick={handleViewingSingleProvider}
                                                            onKeyDown={(e) => {
                                                                if (e.key == 'Enter') {
                                                                    handleViewingSingleProvider();
                                                                }
                                                            }}
                                                            tabIndex="0"
                                                            style={{
                                                                color: '#196ECF',
                                                                fontWeight: '700',
                                                                fontSize: '12.64px',
                                                                marginBottom: '0px',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            View Estimate
                                                        </Typography.Paragraph>
                                                        <ChevronRight
                                                            style={{
                                                                color: '#196ECF',
                                                                height: '16px',
                                                                width: '16px',
                                                                cursor: 'pointer',
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ) : (
                                            <Grid
                                                container
                                                alignItems="center"
                                                direction="row"
                                                sx={{ marginTop: '13px' }}
                                            >
                                                <Typography.Paragraph
                                                    onClick={() => {
                                                        handlesetTopLocation(index);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key == 'Enter') {
                                                            handlesetTopLocation(index);
                                                        }
                                                    }}
                                                    tabIndex="0"
                                                    style={{
                                                        color: '#196ECF',
                                                        fontWeight: '700',
                                                        fontSize: '12.64px',
                                                        marginBottom: '0px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    Use this facility and view estimate
                                                </Typography.Paragraph>
                                                <ChevronRight
                                                    style={{
                                                        color: '#196ECF',
                                                        height: '16px',
                                                        width: '16px',
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    };

    const renderLocationCard = (location, index) => {
        return (
            <React.Fragment key={index}>
                {index % 3 === 0 && index !== 0 && (
                    <Grid item xs={12}>
                        <Divider orientation="horizontal" />
                    </Grid>
                )}
                <Grid
                    item
                    xs={4}
                    aria-label={`locationCard${index}`}
                    label={`locationCard${index}`}
                    key={location.locationId}
                >
                    <Grid
                        container
                        spacing={0}
                        justifyContent="space-between"
                        direction="row"
                        sx={{ height: '100%' }}
                    >
                        {(index - 1) % 3 === 0 ? (
                            <Grid item style={{ marginTop: '24px', marginBottom: '24px' }}>
                                <Divider orientation="vertical" />
                            </Grid>
                        ) : (
                            index === 1 && (
                                <Grid item style={{ marginTop: '24px', marginBottom: '24px' }}>
                                    <Divider orientation="vertical" />
                                </Grid>
                            )
                        )}
                        <Grid item xs={(index - 1) % 3 === 0 ? 11.9 : index === 1 ? 11.9 : 12}>
                            <Paper
                                style={{
                                    borderRadius: '8px',
                                    border:
                                        topLocation === index
                                            ? '4px solid rgba(25, 110, 207, 1)'
                                            : '0px',
                                }}
                                variant="outlined"
                                sx={{
                                    paddingX: '24px',
                                    paddingY: '24px',
                                }}
                            >
                                <Grid container justifyContent="space-between">
                                    <Grid item xs={12}>
                                        <Typography.Paragraph
                                            style={{
                                                color: '#333333',
                                                fontWeight: '500',
                                                fontSize: '14.22px',
                                                marginBottom: '0px',
                                            }}
                                        >
                                            {location.line[0]}, {location.city}, {location.state}{' '}
                                            {location.postalCode}
                                        </Typography.Paragraph>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{ marginTop: '16px', marginBottom: '8px' }}
                                    >
                                        <Grid container justifyContent="space-between">
                                            <Grid item xs={12} sx={{ marginBottom: '14px' }}>
                                                <Grid container alignItems="center">
                                                    <Typography.Paragraph
                                                        style={{
                                                            color: '#5A5A5A',
                                                            marginBottom: '0px',
                                                            fontWeight: '500',
                                                            fontSize: '16px',
                                                        }}
                                                    >
                                                        You pay:
                                                    </Typography.Paragraph>
                                                    <Typography.Paragraph
                                                        data-testid="estimatePrice"
                                                        style={{
                                                            color: '#333333',
                                                            marginBottom: '0px',
                                                            fontWeight: '700',
                                                            fontSize:
                                                                costShare?.outOfPocket ||
                                                                costShare?.outOfPocket == 0
                                                                    ? '25.63px'
                                                                    : '16px',
                                                            marginLeft: '8px',
                                                        }}
                                                    >
                                                        {getMemberPays(estimate, 'Not Available')}
                                                    </Typography.Paragraph>
                                                </Grid>
                                            </Grid>
                                            {/* <Grid item>
                                                {geoAverageCost &&
                                                    !isIndemnity[
                                                        selectedService?.value?.fullCarePath
                                                            ?.coverageTypeCode
                                                    ] && (
                                                        <AverageThresholdTag
                                                            costScale={costScale}
                                                            cost={costShare?.outOfPocket}
                                                            currentDialogState={
                                                                showOtherLocationsModal
                                                            }
                                                            setDialogState={
                                                                setShowOtherLocationsModal
                                                            }
                                                        />
                                                    )}
                                            </Grid> */}
                                            {/* //commenting out the average tag for now but will put behind feature flag */}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {topLocation === index ? (
                                            <Grid container direction="column">
                                                <Grid item>
                                                    <Grid
                                                        container
                                                        alignItems="center"
                                                        direction="row"
                                                    >
                                                        <CheckCircleIcon
                                                            style={{
                                                                color: '#196ECF',
                                                                height: '16px',
                                                                width: '16px',
                                                                marginRight: '8px',
                                                            }}
                                                        />
                                                        <Typography.Paragraph
                                                            style={{
                                                                color: '#333333',
                                                                marginBottom: '0px',
                                                                fontWeight: '400',
                                                                fontSize: '14.22px',
                                                            }}
                                                        >
                                                            This facility is currently selected
                                                        </Typography.Paragraph>
                                                    </Grid>
                                                </Grid>
                                                <Grid item sx={{ marginTop: '13px' }}>
                                                    <Grid
                                                        container
                                                        alignItems="center"
                                                        direction="row"
                                                    >
                                                        <Typography.Paragraph
                                                            onClick={handleViewingSingleProvider}
                                                            onKeyDown={(e) => {
                                                                if (e.key == 'Enter') {
                                                                    handleViewingSingleProvider();
                                                                }
                                                            }}
                                                            tabIndex="0"
                                                            style={{
                                                                color: '#196ECF',
                                                                fontWeight: '700',
                                                                fontSize: '12.64px',
                                                                marginBottom: '0px',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            View Estimate
                                                        </Typography.Paragraph>
                                                        <ChevronRight
                                                            style={{
                                                                color: '#196ECF',
                                                                height: '16px',
                                                                width: '16px',
                                                                cursor: 'pointer',
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ) : (
                                            <Grid
                                                container
                                                alignItems="center"
                                                direction="row"
                                                sx={{ marginTop: '13px' }}
                                            >
                                                <Typography.Paragraph
                                                    onClick={() => {
                                                        handlesetTopLocation(index);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key == 'Enter') {
                                                            handlesetTopLocation(index);
                                                        }
                                                    }}
                                                    tabIndex="0"
                                                    style={{
                                                        color: '#196ECF',
                                                        fontWeight: '700',
                                                        fontSize: '12.64px',
                                                        marginBottom: '0px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    Use this facility and view estimate
                                                </Typography.Paragraph>
                                                <ChevronRight
                                                    style={{
                                                        color: '#196ECF',
                                                        height: '16px',
                                                        width: '16px',
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                        {(index - 1) % 3 === 0 ? (
                            <Grid item style={{ marginTop: '24px', marginBottom: '24px' }}>
                                <Divider orientation="vertical" />
                            </Grid>
                        ) : (
                            index === 1 && (
                                <Grid item style={{ marginTop: '24px', marginBottom: '24px' }}>
                                    <Divider orientation="vertical" />
                                </Grid>
                            )
                        )}
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    };

    return (
        <div aria-label="dialogModalContainer" ref={ref}>
            <Dialog
                fullWidth
                maxWidth="lg"
                open={otherLocationsOpen}
                onClose={handleOtherLocationsClose}
                data-testid="otherLocationsWindow"
                id="otherLocations-dialog"
                fullScreen={!isDesktopView}
                PaperProps={{
                    tabIndex: -1,
                    id: 'otherLocationsDialogChildDiv',
                    'aria-labelledby': 'providerHeaderName',
                }}
            >
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="flex-start"
                    style={{
                        paddingTop: '16px',
                        paddingLeft: '24px',
                        paddingRight: '24px',
                        paddingBottom: '0px',
                    }}
                >
                    <Grid item xs={10}>
                        {isDesktopView ? (
                            <Typography.H2
                                style={{
                                    color: '#196ECF',
                                    marginBottom: '0px',
                                    paddingTop: '40px',
                                }}
                                id="providerHeaderName"
                                data-testid="providerName"
                            >
                                {provider.unTranslatedText}
                            </Typography.H2>
                        ) : (
                            <Typography.H2
                                style={{
                                    color: '#002677',
                                    marginBottom: '0px',
                                    paddingTop: '17px',
                                }}
                                id="providerHeaderName"
                            >
                                {provider.unTranslatedText}
                            </Typography.H2>
                        )}
                    </Grid>
                    {/* Used for mobile view */}
                    <Grid item xs={2} hidden={isDesktopView}>
                        <IconButton
                            title="exit"
                            onClick={handleModalClose}
                            aria-label="Close other locations dialog"
                            data-testid="closeOtherLocationsDialogMobile"
                            style={{ float: 'right' }}
                        >
                            <Clear />
                        </IconButton>
                    </Grid>

                    <Grid item xs={2} textAlign="right" hidden={!isDesktopView}>
                        <IconButton
                            title="exit"
                            onClick={handleModalClose}
                            data-testid="closeOtherLocationsDialog"
                            aria-label="Close other locations dialog"
                        >
                            <Clear />
                        </IconButton>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography.Paragraph style={{ color: '#333333', marginBottom: '8px' }}>
                            {allProviderSpecialties(provider?.locAndPractRole)?.length > 0
                                ? allProviderSpecialties(provider?.locAndPractRole).join(', ')
                                : 'No Specialties Found'}
                        </Typography.Paragraph>
                    </Grid>
                    <Grid item xs={10}>
                        <Grid container direction="row">
                            <Typography.Paragraph
                                style={{
                                    color: '#333333',
                                    marginBottom: '16px',
                                    fontSize: '14.22px',
                                    fontWeight: 700,
                                }}
                            >
                                {`${
                                    provider?.locAndPractRole?.length
                                        ? provider.locAndPractRole?.length
                                        : 1
                                } location(s)`}
                            </Typography.Paragraph>
                            <Typography.Paragraph
                                style={{
                                    color: '#333333',
                                    marginBottom: '16px',
                                    fontSize: '14.22px',
                                    marginLeft: '4px',
                                }}
                            >
                                for this procedure
                            </Typography.Paragraph>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider aria-hidden="true" role="presentation" />
                    </Grid>
                </Grid>

                <DialogContent aria-label="locationsList">
                    <Grid container>
                        {isDesktopView ? renderAllLocations() : renderAllLocationsMobile()}
                    </Grid>
                </DialogContent>
                <DialogActions
                    aria-label="otherLocationsActions"
                    style={{
                        paddingLeft: '24px',
                        paddingRight: '24px',
                        paddingTop: '32px',
                        paddingBottom: '32px',
                    }}
                >
                    <Grid container alignItems="center" justify="flext-start">
                        <Grid item hidden={!isDesktopView}>
                            <Button
                                aria-label="closeLocationsWindowButtonMapView"
                                variant="contained"
                                color="primary"
                                onClick={handleOtherLocationsClose}
                            >
                                Close
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>
    );
};

OtherLocationsModal.propTypes = {
    otherLocationsOpen: PropTypes.bool.isRequired,
    handleOtherLocationsClose: PropTypes.func.isRequired,
    topLocation: PropTypes.number.isRequired,
};

OtherLocationsModal.defaultProps = {
    otherLocationsOpen: false,
};

export default OtherLocationsModal;
